module.exports = __webpack_public_path__ + "static/media/left2_hover.7df57d50.svg";